import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import toast, { Toaster } from "react-hot-toast";
import Chart from "react-apexcharts";
import { getDealerVisitPerDayADMIN, getPJPdataADMIN, getTimeSpentDealerADMIN, getVisitsByTimeSpent, getVisitsData } from "_controllers/officer";

const AdminDashboard = () => {
    const [visitByDistance, setVisitByDistance] = useState();
    const [visitType, setVisitType] = useState();
    const [uniqueVisits, setUniqueVisits] = useState();
    const [activeVisits, setActiveVisits] = useState();
    const [activeDealerVisits, setActiveDealerVisits] = useState(0)
    const [inactiveDealerVisits, setInactiveDealerVisits] = useState(0)
    const [pjpData, setPjpData] = useState([])
    const [perDayVisitData, setPerDayVisitData] = useState([])
    const [dealerTimeSpent, setDealerTimeSpent] = useState({})

    const [loader1, setLoader1] = useState(true)
    const [loader2, setLoader2] = useState(true)
    const [loader3, setLoader3] = useState(true)
    const [loader4, setLoader4] = useState(true)
    const [loader5, setLoader5] = useState(true)

    useEffect(async () => {
        console.log("inside");
        const data = await getVisitsData({
            // zone,
            // startDate,
            // endDate,
        });
        console.log("ji data", data);
        setVisitType(data?.visitType);
        setActiveDealerVisits(data?.visitByDealerStatus.reduce((acc, obj) => {
            if (obj._id === "A") {
                acc += obj.count;
            }
            return acc;
        }, 0))
        setInactiveDealerVisits(data?.visitByDealerStatus.reduce((acc, obj) => {
            if (obj._id === "I") {
                acc += obj.count;
            }
            return acc;
        }, 0))
        setUniqueVisits(data?.uniqueDealerVisits);
        setActiveVisits(data?.activeDealerVisits);
        setLoader1(false)
    }, []);

    useEffect(async () => {
        console.log("inside");
        const data = await getVisitsByTimeSpent({
            // zone,
            // startDate,
            // endDate,
        });
        setVisitByDistance(data);
        setLoader2(false)
    }, []);

    useEffect(async () => {
        await getPJPdataADMIN({
            // startDate,
            // endDate,
        }).then((data) => {
            setPjpData(data)
            setLoader3(false)
        }).catch((err) => {
            console.log("err", err);
        })
    }, []);

    useEffect(async () => {
        await getDealerVisitPerDayADMIN({
            // startDate,
            // endDate,
        }).then((data) => {
            setPerDayVisitData(data)
            setLoader4(false)
        }).catch((err) => console.log("err", err))
    }, []);

    useEffect(async () => {
        await getTimeSpentDealerADMIN({
            // startDate,
            // endDate,
        }).then((data) => {
            let obj = {}
            obj["NZ"] = data?.data?.dataNZ.length > 0 ? data?.data?.dataNZ[0].time : 0,
                obj["SZ"] = data?.data?.dataSZ.length > 0 ? data?.data?.dataSZ[0].time : 0,
                obj["EZ"] = data?.data?.dataEZ.length > 0 ? data?.data?.dataEZ[0].time : 0,
                obj["WZ"] = data?.data?.dataWZ.length > 0 ? data?.data?.dataWZ[0].time : 0,
                obj["SZII"] = data?.data?.dataSZII.length > 0 ? data?.data?.dataSZII[0].time : 0,
                setDealerTimeSpent(obj)
            setLoader5(false)
            // setAvgTimeLoader(false)
        }).catch((err) => console.log("err", err))
    }, []);

    // useEffect(async () => {
    //     let val = navigator.geolocation.getCurrentPosition((res => console.log("VALUE", res)))
    //     console.log("VALUE", val);
    // }, [])

    console.log("loader", loader1, loader2, loader3, loader4, loader5);

    return (
        <>
            <Grid
                container
                spacing={2}
                style={{
                    border: "1px solid #eaeaea",
                    margin: "1rem",
                    width: "96.5%",
                    borderRadius: "10px",
                    boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                }}
            >
                <Grid item xs={12} md={12} xl={12}>
                    <Typography align="center" variant="h4" sx={{ mt: 1, mb: 2.5 }}>
                        ADMIN DASHBOARD
                    </Typography>
                </Grid>
                {loader1 === true ? (
                    <CircularProgress />
                ) : (
                    <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                        <Chart
                            type="donut"
                            width={'100%'}
                            height={'100%'}
                            series={[visitType.planned, visitType.unplanned]}
                            options={{
                                labels: ["Planned", "Unplanned"],
                                title: {
                                    text: "Visit Type",
                                    align: "center",
                                },
                                plotOptions: {
                                    pie: {
                                        startAngle: -90,
                                        endAngle: 90,
                                        // offsetY: 10,
                                    },
                                },
                                yaxis: {
                                    labels: {},
                                },
                                legend: {
                                    position: "top",
                                },
                            }}
                        ></Chart>
                    </Grid>
                )}

                {loader1 === true ? (
                    <CircularProgress />
                ) : (
                    <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                        <Chart
                            type="donut"
                            width={'100%'}
                            height={'100%'}
                            series={[activeDealerVisits ?? 0, inactiveDealerVisits ?? 0]}
                            options={{
                                labels: ["Active", "In-Active"],
                                title: {
                                    text: "Visit By Dealer Status",
                                    align: "center",
                                },
                                plotOptions: {
                                    pie: {
                                        startAngle: -90,
                                        endAngle: 90,
                                        // offsetY: 10,
                                    },
                                },
                                yaxis: {
                                    labels: {},
                                },
                                legend: {
                                    position: "top",
                                },
                            }}
                        />
                    </Grid>
                )}

                {loader1 === true ? (
                    <CircularProgress />
                ) : (
                    <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                        <Chart
                            type="donut"
                            width={'100%'}
                            height={'100%'}
                            series={[
                                uniqueVisits?.uniqueVisits,
                                uniqueVisits?.totalVisits - uniqueVisits?.uniqueVisits,
                            ]}
                            options={{
                                labels: ["Unique Dealers Visits", "Repeated Dealers"],
                                title: {
                                    text: "Unique Dealer Visits.",
                                    align: "center",
                                },
                                plotOptions: {
                                    pie: {
                                        startAngle: -90,
                                        endAngle: 90,
                                        // offsetY: 10,
                                        donut: {
                                            labels: {
                                                show: true,
                                                name: {
                                                    // title: "jskjaksjksj",
                                                    formatter: function (val) {
                                                        return "Total Visits";
                                                    },
                                                },
                                                total: {
                                                    show: true,
                                                    formatter: function (val) {
                                                        return uniqueVisits?.totalVisits;
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                                // yaxis: {
                                //   labels: {},
                                // },
                                legend: {
                                    position: "top",
                                },
                            }}
                        />
                    </Grid>
                )}

                {loader1 === true ? (
                    <CircularProgress />
                ) : (
                    <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                        <Chart
                            type="donut"
                            width={'100%'}
                            height={'100%'}
                            series={[activeVisits?.visits, activeVisits?.totalDealers]}
                            options={{
                                labels: ["Unique Dealers", "Active Dealers"],
                                title: {
                                    text: "Total Visits/ Active Dealer Base",
                                    align: "center",
                                },
                                plotOptions: {
                                    pie: {
                                        startAngle: -90,
                                        endAngle: 90,
                                        // offsetY: 10,
                                    },
                                },
                                yaxis: {
                                    labels: {},
                                },
                                legend: {
                                    position: "top",
                                },
                            }}
                        />
                    </Grid>
                )}

                {loader2 === true ? (
                    <CircularProgress />
                ) : (
                    <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                        <Chart
                            type="donut"
                            width={'100%'}
                            height={'100%'}
                            series={[
                                visitByDistance?.pendingVisits,
                                visitByDistance?.lessThan100,
                                visitByDistance?.moreThan100,
                            ]}
                            options={{
                                labels: ["Not-Ended", ">100m", "<100m"],
                                title: {
                                    text: "Visit By Start & End Location.",
                                    align: "center",
                                },
                                yaxis: {
                                    labels: {},
                                },
                                legend: {
                                    position: "top",
                                },
                            }}
                        />
                    </Grid>
                )}

                {
                    loader4 === true ?
                        <CircularProgress /> :
                        <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                            <Chart
                                type="bar"
                                width={'100%'}
                                height={'100%'}
                                series={[
                                    {
                                        name: "Last Month",
                                        data: [
                                            perDayVisitData?.northZoneData?.previousMonth,
                                            perDayVisitData?.westZoneData?.previousMonth,
                                            perDayVisitData?.eastZoneData?.previousMonth,
                                            perDayVisitData?.southZoneData?.previousMonth,
                                            perDayVisitData?.southZoneIIData?.previousMonth,
                                        ],
                                        // color: "greenyellow",
                                    },
                                    {
                                        name: "Current Month",
                                        data: [
                                            perDayVisitData?.northZoneData?.currentMonth,
                                            perDayVisitData?.westZoneData?.currentMonth,
                                            perDayVisitData?.eastZoneData?.currentMonth,
                                            perDayVisitData?.southZoneData?.currentMonth,
                                            perDayVisitData?.southZoneIIData?.currentMonth,
                                        ],
                                    },
                                ]}
                                options={{
                                    labels: ["NORTH", "WEST", "EAST", "SOUTH-I", "SOUTH-II"],
                                    title: {
                                        text: "Average Dealer Visits/Day.",
                                        align: "center",
                                    },
                                    chart: {
                                        toolbar: {
                                            show: false, //Disable toolbar
                                        },
                                    },
                                    plotOptions: {
                                        bar: {
                                            dataLabels: {
                                                position: 'top', // top, center, bottom
                                            },
                                        }
                                    },
                                    dataLabels: {
                                        enabled: true,
                                        offsetY: -20,
                                        style: {
                                            fontSize: '12px',
                                            colors: ["#304758"]
                                        }
                                    },
                                    stroke: {
                                        show: true,
                                        width: 3,
                                        colors: ['transparent']
                                    },
                                    legend: {
                                        position: "top",
                                    },
                                    tooltip: { followCursor: true },
                                    yaxis: {
                                        labels: {},
                                    },
                                }}
                            />
                        </Grid>
                }

                {
                    loader3 === true ?
                        <CircularProgress /> :
                        <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                            <Chart
                                type="bar"
                                width={'100%'}
                                height={'100%'}
                                series={[
                                    {
                                        name: "NO",
                                        data: [
                                            pjpData?.EZData?.PJPNotCreated,
                                            pjpData?.WZData?.PJPNotCreated,
                                            pjpData?.SZData?.PJPNotCreated,
                                            pjpData?.NZData?.PJPNotCreated,
                                            pjpData?.SZIIData?.PJPNotCreated
                                        ],
                                        // color: "greenyellow",
                                    },
                                    {
                                        name: "YES",
                                        data: [
                                            pjpData?.NZData?.PJPCreated,
                                            pjpData?.WZData?.PJPCreated,
                                            pjpData?.EZData?.PJPCreated,
                                            pjpData?.SZData?.PJPCreated,
                                            pjpData?.SZIIData?.PJPCreated
                                        ],
                                    },
                                ]}
                                options={{
                                    labels: ["NORTH", "WEST", "EAST", "SOUTH-I", "SOUTH-II"],
                                    title: {
                                        text: "PJP planning status.",
                                        align: "center",
                                    },
                                    chart: {
                                        toolbar: {
                                            show: false, //Disable toolbar
                                        },
                                    },
                                    stroke: {
                                        show: true,
                                        width: 3,
                                        colors: ['transparent']
                                    },
                                    tooltip: { followCursor: true },
                                    yaxis: {
                                        labels: {},
                                    },
                                    legend: {
                                        position: "top",
                                    },
                                }}
                            />
                        </Grid>
                }

                {
                    loader5 === true ?
                        <CircularProgress /> :
                        <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
                            <Chart
                                type="bar"
                                width={'100%'}
                                height={'100%'}
                                series={[
                                    {
                                        name: "Last Month",
                                        data: [
                                            dealerTimeSpent?.NZ,
                                            dealerTimeSpent?.WZ,
                                            dealerTimeSpent?.EZ,
                                            dealerTimeSpent?.SZ,
                                            dealerTimeSpent?.SZII
                                        ],
                                    },
                                ]}
                                options={{
                                    labels: ["NORTH", "WEST", "EAST", "SOUTH-I", "SOUTH-II"],
                                    title: {
                                        text: "Average Time Spent/Dealer (mins).",
                                        align: "center",
                                    },
                                    plotOptions: {
                                        bar: {
                                            columnWidth: "70%"
                                        }
                                    },
                                    chart: {
                                        toolbar: {
                                            show: false, //Disable toolbar
                                        },
                                    },
                                    tooltip: { followCursor: true },
                                    yaxis: {
                                        labels: {},
                                    },
                                }}
                            />
                        </Grid>
                }

            </Grid>
        </>
    )
}

export default AdminDashboard